import { http } from "api/http";

const getExpiryData = ({ queryKey }) => {
  return http.get("/home/get-expairy-data", { params: { ...queryKey[1] } });
};

const getPriorityStatus = () => {
  return http.get("home/get-priority-status");
};

const getDocumentStatus = () => {
  return http.get("home/get-document-status");
};

export { getExpiryData, getPriorityStatus, getDocumentStatus };
